import { axiosApi } from "../../../api/dbAxios";

export const fetchUserList = async () => {
  try {
    const response = await axiosApi.get(`/roles/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching item list:", error);
    return [];
  }
};
